// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"TableHead_tableHeader__dXAB0","tableCell_first":"TableHead_tableCell_first__2amge"};